export const LEGACY_LOCALSTORAGE_KEY = 'access';
export const LOCALSTORAGE_SESSIONTOKEN_KEY = 'access-token';
export const AUTHCODE_ID_KEY = 'authcode';
export const STORAGE_KEY_REFERRER_CODE = 'referrerCode';
export const URL_PARAM_REFERRER_CODE = 'referrercode';